import { createFileRoute } from '@tanstack/react-router';

import { NotImplementedPage } from '@apple/ui/shell/pages/NotImplementedPage';

export const Route = createFileRoute('/_authed/_admin/reports/supportRequests')({
	component: () => <NotImplementedPage name='Support Requests' />,
});
